import {
  PRODUCTS_DROPSHIP,
  PRODUCTS_DROPSHIP_OFFSET,
  PRODUCTS_DROPSHIP_COUNT,
  PRODUCTS_DROPSHIP_RETAILERS,
  PRODUCTS_DROPSHIP_SEARCH,
  PRODUCTS_DROPSHIP_CHECK,
  PRODUCTS_DROPSHIP_UNCHECK,
  PRODUCTS_DROPSHIP_CHECK_ALL_ON_PAGE,
  PRODUCTS_DROPSHIP_UNCHECK_ALL,
  PRODUCTS_DROPSHIP_ALL,
  PRODUCTS_DROPSHIP_LOADING,
} from '../constants/productsDropshipTypes';
import { ROLES_CURRENT_ROLE } from '../constants/rolesTypes';

const initialState = {
  data: null,
  offset: 0,
  count: 0,
  retailers: [],
  perPage: 50,
  search: '',
  checked: {},
  loading: {
    products: false,
  },
};

const productsDropship = (state = initialState, action) => {
  switch (action.type) {
    case ROLES_CURRENT_ROLE:
      return { ...initialState };
    case PRODUCTS_DROPSHIP:
      return {
        ...state,
        data: action.payload,
      };
    case PRODUCTS_DROPSHIP_OFFSET:
      return {
        ...state,
        offset: action.payload,
      };
    case PRODUCTS_DROPSHIP_COUNT:
      return {
        ...state,
        count: +action.payload,
      };
    case PRODUCTS_DROPSHIP_RETAILERS:
      return {
        ...state,
        retailers: action.payload,
      };
    case PRODUCTS_DROPSHIP_SEARCH:
      return {
        ...state,
        search: action.payload,
      };
    case PRODUCTS_DROPSHIP_CHECK:
      return {
        ...state,
        checked: {
          ...state.checked,
          [action.payload.model]: action.payload.variants,
        },
      };
    case PRODUCTS_DROPSHIP_UNCHECK:
      const newChecked = { ...state.checked };
      delete newChecked[action.payload.model];

      return {
        ...state,
        checked: newChecked,
      };
    case PRODUCTS_DROPSHIP_CHECK_ALL_ON_PAGE:
      return {
        ...state,
        checked: {
          ...state.checked,
          ...action.payload,
        },
      };
    case PRODUCTS_DROPSHIP_UNCHECK_ALL:
      return {
        ...state,
        checked: {},
      };
    case PRODUCTS_DROPSHIP_ALL:
      const checkedAll = {};
      action.payload.forEach((product) => {
        checkedAll[product.model] = product.variants;
      });
      return {
        ...state,
        checked: checkedAll,
      };
    case PRODUCTS_DROPSHIP_LOADING:
      return {
        ...state,
        loading: {
          ...state.loading,
          ...action.payload,
        },
      };

    default:
      break;
  }

  return state;
};

export default productsDropship;
